import { getDefaultTenantBaseUrl } from '../pages/labs/home/constants';

export const QUERY_BUILDER_GRAPHQL_BASE_URL: string = getDefaultTenantBaseUrl();

/** Standard JSON content-type header value, shared across GraphQL request callers. */
export const JSON_CONTENT_TYPE = 'application/json' as const;

/**
 * Returns the correct AGG GraphQL endpoint URL for the current environment.
 * In local development the proxy path is returned to avoid CORS issues;
 * in production the full URL (origin + path) is returned.
 */
export const getGraphQLEndpointUrl = (
	basePath: string = '/gateway/api/graphql',
	baseUrl: string = getDefaultTenantBaseUrl(),
): string => {
	const isDev =
		typeof window !== 'undefined' &&
		(window.location.hostname === 'localhost' || window.location.hostname.includes('localhost'));
	return isDev ? basePath : `${baseUrl}${basePath}`;
};
